import { LinearGradient } from 'expo-linear-gradient';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { Colors } from '@/constants/theme';
import { useColorScheme } from '@/hooks/use-color-scheme';

const TAB_BAR_HEIGHT = 65;
const GRADIENT_FADE_HEIGHT = 35;

/**
 * TabBarGradientBlur - Gradient overlay above tab bar
 *
 * Creates a fade-to-background effect as content approaches the tab bar.
 * Positioned above content (zIndex 10) but below tab bar (zIndex 20).
 * Uses pointerEvents="none" to allow touch passthrough.
 */
export function TabBarGradientBlur() {
  const colorScheme = useColorScheme();
  const insets = useSafeAreaInsets();
  const palette = Colors[colorScheme ?? 'light'];
  const backgroundColor = palette.background;

  // Build gradient colors from transparent (top) to 95% opacity, reaching full opacity quickly
  const gradientColors = [
    'transparent',          // 0% - top (fully transparent)
    `${backgroundColor}D9`, // 85% opacity - middle fade zone
    `${backgroundColor}F2`, // 95% opacity - at tab bar top edge
  ] as const;

  // Total height: tab bar + safe area + fade zone above
  const totalHeight = TAB_BAR_HEIGHT + insets.bottom + GRADIENT_FADE_HEIGHT;

  return (
    <View
      style={[styles.container, { height: totalHeight }]}
      pointerEvents="none"
    >
      <LinearGradient
        colors={gradientColors}
        locations={[0, 0.15, 0.45]}
        style={styles.gradient}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
  },
  gradient: {
    flex: 1,
  },
});
